import SearchQuickList from './SearchQuickList'

export default SearchQuickList
